"use client";
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const location = useLocation();
  const path = location.pathname;
  const { t } = useTranslation();

  const shouldBeRelative = path === '/privacy' || path === '/termsofuse' || path === "/blog-detail";

  return (
    <div className='footer-mob'> 
      <footer className="footer">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="d-flex justify-content-center gap-4">
              <p>
                <Link to="/termsofuse" className="fw-bolder">
                  <b>{t('footer.terms')}</b>
                </Link>
              </p>
              <p>|</p>
              <p>
                <Link to="/privacy" className="fw-bolder">
                  <b>{t('footer.privacyPolicy')}</b>
                </Link>
              </p>
              <p>|</p>
              <p>
                <a href="https://www.izzygo.pro/contact.html" className="fw-bolder" target='_blank'>
                  <b>{t('footer.contactUs')}</b>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
    </div>
  );
};

export default Footer;
